import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Seguidores',
  fields: {
    name: 'Nome:',
    email: 'E-mail:',
    phone_number: 'Telefone:',
    subscribed: 'Subscrito:',
    birthday: 'Aniversário:',
    location: 'Localização:',
    followed: 'A seguir:',
    lifetime_spent: 'Total gasto:',
    total_orders: 'Total de pedidos:',
    google_review: 'Avaliação Google:',
    loyalty_lifetime: 'Fidelidade total:',
    loyalty_points: 'Fidelidade hoje:',
  },
  labels: {
    yes: 'Sim',
    no: 'Não',
    followed_since_date: 'Desde {{date}}',
  },
  buttons: {
    edit: 'Editar',
    request_data_deletion: 'Solicitar eliminação de dados',
  },
  toasts: {
    failed_to_load_data: 'Erro ao carregar dados',
  },
  tabs: {
    recent_orders: {
      title: 'Pedidos recentes',
      columns: {
        order_id: 'Id',
        items: 'Artigos',
        total: 'Valor total',
        paid_on: 'Pago em',
        payment_method: 'Método de pagamento',
      },
      labels: {
        no_orders: 'Sem pedidos ainda',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Cartão',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Débito bancário',
        [PaymentMethods.CASH]: 'Dinheiro',
        [PaymentMethods.BACS_DEBIT]: 'Débito bancário',
      },
    },
    messages: {
      title: 'Mensagens',
      columns: {
        template: 'Modelo',
        status: 'Estado',
        opened: 'Aberto',
        clicked: 'Clicado',
        spam_complaint: 'Queixa de spam',
        unsubscribed: 'Desinscrito',
        sent_at: 'Enviado em',
      },
      labels: {
        yes: 'Sim',
        no: 'Não',
        not_detected: 'Não detetado',
        opened_at: 'Aberto em {{date}}',
        clicked_at: 'Clicado em {{date}}',
        complained_at: 'Queixa em {{date}}',
        unsubscribed_at: 'Desinscrito em {{date}}',
        no_messages: 'Ainda sem mensagens',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Enviado',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Entregue',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Falhou',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Erro ao carregar dados',
      },
    },
    balance_history: {
      title: 'Histórico de saldo',
      columns: {
        created_at: 'Data',
        source: 'Fonte',
        value: 'Pontos',
        points_expire_at: 'Expira em',
      },
      labels: {
        source: {
          welcome_bonus: 'Bónus de boas-vindas',
          google_review_reward: 'Recompensa por avaliação Google',
          reward_loyalty_program_conversion: 'Recompensa por conversão no programa de fidelização',
          cashback: 'Cashback',
          refund: 'Reembolso',
          cashback_usage: 'Utilização de cashback',
          cashback_usage_refund: 'Reembolso de utilização de cashback',
          expired_points_void: 'Anulação de pontos expirados',
          mobile_app_signup_bonus: 'Bónus de registo na app móvel',
        },
        no_operations: 'Ainda sem operações',
      },
    },
  },
};
